/**
 * Version Telemetry
 *
 * Provides structured logging for stale frontend detection.
 * Uses Datadog browser logs in production, console.log in development.
 *
 * Messages include "[Kaleidoscope]" prefix for easy filtering in Datadog.
 */

import { datadogLogs } from '@datadog/browser-logs';

const isDev = import.meta.env.DEV;

function log(event: string, context: Record<string, unknown>): void {
	const message = `[Kaleidoscope] Version ${event}`;
	if (isDev) {
		console.info(`[Telemetry] ${message}`, context);
	} else {
		datadogLogs.logger.info(message, context);
	}
}

/**
 * Version telemetry events for tracking stale frontend detection.
 */
export const versionTelemetry = {
	/**
	 * Logged when the version mismatch banner is displayed to the user.
	 */
	bannerShown: (userId: string, companyId: string, currentVersion: string, expectedVersion: string) => {
		log('banner_shown', {
			user_id: userId,
			company_id: companyId,
			current_version: currentVersion,
			expected_version: expectedVersion,
		});
	},

	/**
	 * Logged when the user clicks the refresh button on the version banner.
	 */
	refreshClicked: (userId: string, companyId: string, currentVersion: string, expectedVersion: string) => {
		log('refresh_clicked', {
			user_id: userId,
			company_id: companyId,
			current_version: currentVersion,
			expected_version: expectedVersion,
		});
	},

	/**
	 * Logged when the user dismisses the version banner without refreshing.
	 */
	bannerDismissed: (userId: string, companyId: string, currentVersion: string, expectedVersion: string) => {
		log('banner_dismissed', {
			user_id: userId,
			company_id: companyId,
			current_version: currentVersion,
			expected_version: expectedVersion,
		});
	},
};
